import {Component, Input, Output, SimpleChanges, EventEmitter, ViewChild, ElementRef, forwardRef} from '@angular/core';
import {SistemaService} from '../../Servicios/Sistema.Service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {AppService} from '../../app.service';

declare var $: any;
declare function Focus(id : string) : any;

const noop = () =>
{
};

export const CUSTOM_MULTISELECT_CONTROL_VALUE_ACCESSOR: any =
  {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiSelectComponent),
    multi: true
  };

@Component(
  {
    selector: 'multiSelect',
    templateUrl: './MultiSelect.template.html',
    styleUrls: ['./MultiSelect.scss'],
    providers: [CUSTOM_MULTISELECT_CONTROL_VALUE_ACCESSOR]
  })

export class MultiSelectComponent implements ControlValueAccessor
{
  @ViewChild('ddMenu') ddMenu! : ElementRef;

  public innerValue : string = "";
  public datoSeleccionado : any;

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  @Input() titulo : string = ""; // titulo del multiselect
  @Input() opciones : Array<any> = []; // lista de opciones
  @Input() valorName : string = ""; // nombre del atributo que se identificara como seleccionado, por ejemplo el id
  @Input() displayValor : string = ""; // nombre del que se desplegará
  @Input() displayValorIcon : string = ""; // icono que se desplegará junto al nombre

  @Input() buscar : boolean = true; // indica si se mostrará el campo de busqueda
  @Input() limpiarInput : boolean = true; // muestra o no el botón para limpiar la seleccion
  @Input() seleccionarTodos : boolean = true; // muestra o no el botón para seleccionar todos

  @Input() margenControl : boolean = true; // indica si el control lleva un margen de 30px (se recomienda para que el control sea responsivo automáticamente)

  @Input() clasesAdicionales : string = ""; // clases que se agregan al control

  @Input() errorActivo : boolean = false; // indica si el error esta habilitado para mostrarse
  @Input() verError : boolean = true; // indica si se muestra el error
  @Input() disabled : boolean = false; // indica si el control esta deshabilitado
  @Input() mensajeError : string = "Selecciona al menos una opción"; // mensaje que desplegará cuando haya un error

  public busqueda : string = ""; // campo de busqueda

  public id : number = 0;
  public seleccionadosTodos : boolean = false;
  public cadenaSeleccionados : string = "";

  constructor(public sistemaService : SistemaService, public appService : AppService)
  {
    this.sistemaService.numeroControl++;
    this.id = this.sistemaService.numeroControl;
  }

  ngOnInit()
  {

  }

  SeleccionarOpcion(opcion : any)
  {
    this.EvitarCierre();

    // set dato
    opcion.Seleccionado = !opcion.Seleccionado;

    let seleccionado = [];

    if (this.valor)
    {
      seleccionado = this.valor.slice();
    }

    if (opcion.Seleccionado)
    {
      seleccionado.push(opcion[this.valorName]);
    }
    else
    {
      this.sistemaService.BorrarElementoValorPorValor(seleccionado, opcion[this.valorName]);
    }

    this.valor = seleccionado;
  }

  SetDatoSelecciondo()
  {
    this.datoSeleccionado = [];
    this.cadenaSeleccionados = "";

    if (this.valor)
    {
      for(let k = 0; k < this.opciones.length; k++)
      {
        this.opciones[k].Seleccionado = false;

        for (let i = 0; i < this.valor.length; i++)
        {
          if (this.opciones[k][this.valorName] == this.valor[i])
          {
            this.datoSeleccionado.push(this.opciones[k]);
            this.opciones[k].Seleccionado = true;
            this.cadenaSeleccionados += this.opciones[k][this.displayValor] + ", ";
            break;
          }
        }
      }

      this.cadenaSeleccionados = this.cadenaSeleccionados.substr(0 , this.cadenaSeleccionados.length - 2);

      if (this.valor.length == 0)
      {
        this.seleccionadosTodos = false;
      }
      else if (this.valor.length == this.opciones.length)
      {
        this.seleccionadosTodos = true;
      }

    }
  }

  CambiarSeleccionarTodos()
  {
    this.EvitarCierre();
    this.seleccionadosTodos = !this.seleccionadosTodos;

    if (this.seleccionadosTodos)
    {
      let seleccionado = [];

      if (this.valor)
      {
        seleccionado = this.valor.slice();
      }

      this.opciones.forEach((p : any) =>
      {
        if (!p.Seleccionado)
        {
          seleccionado.push(p[this.valorName]);
        }
      });

      this.valor = seleccionado;
    }
    else
    {
      this.valor = [];
    }
  }

  LimpiarSelect()
  {
    this.EvitarCierre();

    this.valor = [];
    this.seleccionadosTodos = false;
  }

  LimpiarBusqueda()
  {
    this.EvitarCierre();
    this.FocusBuscar();
  }

  FocusBuscar()
  {
    if (this.buscar)
    {
      this.busqueda = '';

      setTimeout(() =>
      {
        Focus('buscar' + this.id);
      }, 0);
    }
  }

  EvitarCierre()
  {
    $('#multiSelect' + this.id).click(function(e : any)
    {
      e.stopPropagation();
    });
  }

  // control ngModel
  get valor(): any
  {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set valor(nuevoValor: any)
  {
    if (nuevoValor !== this.innerValue)
    {
      this.innerValue = nuevoValor;
      this.SetDatoSelecciondo();
      this.onChangeCallback(nuevoValor);
      //console.log("valor");
    }
  }

  writeValue(valor: any)
  {
    if (valor !== this.innerValue)
    {
      this.innerValue = valor;
      this.SetDatoSelecciondo();
      //console.log("writeValue");
    }
  }

  registerOnChange(fn: any)
  {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any)
  {
    this.onTouchedCallback = fn;
  }
}
